import isempty from 'lodash/isEmpty';

import EdapActions from '../actions/edapActions';
import RequestToBookModalActions from '../actions/requestToBookModalActions';
import TripActions from '../actions/tripActions';
import ListingActions from '../actions/listingActions';
import RouterActions from '../actions/routerActions';

import {getPricingInfoFromState} from './utils/getPricingInfoFromState';
import {getMaxAdultsFromHouseRules, hasValidGuestCount, hasValidPets} from '../utils/guests';
import {availableRoutes} from '../routes';

/*
    state: {
        listingReducer: {
            propertyOlb: true
            pricingInfo: (get){<listingID: {checkoutError: '', checkoutUrl: ''}}
        },
        tripDetailsReducer: {
            adults: 1,
            arriveDateText: '',
            departDateText: ''
        },
        listingPageReducer: {
            validDates: {datesValid: true}
        }
    }
}
*/

function getBookingUrl(state) {
    const pricingInfo = getPricingInfoFromState(state);
    return pricingInfo.checkoutUrl || null;
}

function hasCheckoutObjNoError(state) {
    const listingObjJs = getPricingInfoFromState(state);
    const checkoutError = listingObjJs.checkoutError;

    return !isempty(listingObjJs) && !checkoutError;
}

function pricingReadyForCheckout(state) {
    const isAvailable = hasCheckoutObjNoError(state);
    const bookingUrl = getBookingUrl(state);

    return isAvailable && !!bookingUrl;
}

function invalidGuests(state) {
    const {
        tripDetailsReducer: {adults, children, hasPets},
        listingReducer: {sleeps, petsAllowed}
    } = state;

    const maxAdults = getMaxAdultsFromHouseRules(state.listingExtendedReducer.houseRules);
    const validGuests = hasValidGuestCount({
        adults,
        children,
        maxAdults,
        sleeps,
        isEmptyValid: false
    });
    const validPets = hasValidPets({hasPets, petsAllowed});

    return !validGuests || !validPets || !adults;
}

function invalidDates(state) {
    const {datesValid} = state.listingPageReducer.validDates;
    return !datesValid;
}

/* eslint-disable complexity */
function primaryCTAClicked(store, action = {payload: {}}) {
    const state = store.getState();
    const {listingReducer, systemReducer, travelerFeaturesReducer} = state;
    const {isMobile} = systemReducer;
    const {actionLocation} = action.payload;
    const loggedIn = travelerFeaturesReducer.isLoggedIn;

    const readyForCheckout = pricingReadyForCheckout(state);
    const promptDateChanges = invalidDates(state);
    const promptGuestChanges = invalidGuests(state);

    if (listingReducer.onlineBookable) {
        store.dispatch(EdapActions.triggerEdapListingBooknowClick(actionLocation || 'right rail'));
        store.dispatch(EdapActions.triggerEdapCheckoutSelected());
        if (readyForCheckout && !promptDateChanges && !promptGuestChanges) {
            store.dispatch(RequestToBookModalActions.requestToBookModalSubmit());
        } else if (promptDateChanges) {
            store.dispatch(TripActions.setBookingFlow(true));
            store.dispatch(ListingActions.openDatePickerModal());
        } else if (promptGuestChanges) {
            store.dispatch(TripActions.setBookingFlow(true));
            store.dispatch(ListingActions.openGuestSelectorModal());
        } else {
            store.dispatch(ListingActions.setRequestToBookModalOpen(true));
        }
    } else {
        if (!loggedIn) {
            store.dispatch(ListingActions.setInquiryLoginModalOpen(true));
            return;
        }

        if (isMobile) {
            // Use routes
            store.dispatch(
                RouterActions.navigateTo(
                    `${systemReducer.baseUrlPath}?r=${availableRoutes.INQUIRY}`
                )
            );
        } else {
            store.dispatch(ListingActions.setInquiryModalOpen(true));
        }

        store.dispatch(
            EdapActions.triggerEdapEvent('generic.modal', {
                modalname: 'inquiry',
                modalaction: 'open'
            })
        );
    }
}
/* eslint-enable complexity */

export default primaryCTAClicked;
export {primaryCTAClicked};
